import React from 'react';

import { isChangedFromDefault, TimeBandRow } from '~support-at-home/lib/timeBands';

import { ClickableIcon } from '~components';
import { faArrowRotateBack } from '~components/icon';

interface ComponentProps {
  row: TimeBandRow;
  onReset?: (row: TimeBandRow) => void;
  canUpdate?: boolean;
}

/**
 * Puts one band back to the platform's own times. The user never has to know what those times were,
 * which is the whole point of the control - so it stays visible, and only disables, once the band
 * already matches.
 */
const ResetBandAction: React.FC<ComponentProps> = ({ row, onReset, canUpdate = false }) => {
  if (!row.is_editable || !canUpdate) return <></>;

  const isAtDefault = !isChangedFromDefault(row);

  return (
    <div className="d-flex justify-content-center">
      <ClickableIcon
        id={`${row.tag}-reset`}
        dataCy={`sah-time-bands-reset-${row.tag}`}
        icon={faArrowRotateBack}
        size="small"
        color="secondary"
        disabled={isAtDefault}
        showTooltipWhenDisabled
        ariaLabel={`Reset ${row.name} to the platform times`}
        toolTip={
          isAtDefault ? `${row.name} is already on the platform times` : `Reset ${row.name} to the platform times`
        }
        onClick={() => onReset?.(row)}
      />
    </div>
  );
};

export default ResetBandAction;
